import { applyPlatformClasses, isNative, platform } from './platform.js';
import { installChrome } from './chrome.js';
import { installBackButton } from './navigation.js';
import { installLifecycle } from './lifecycle.js';
import { installLinks } from './links.js';
import { installHaptics } from './haptics.js';

/**
 * Bootstraps the native shell.
 *
 * Every module below is safe on the web — each one checks the platform itself
 * and degrades to either a browser equivalent or a no-op — so there is a single
 * code path to reason about rather than two builds.
 */
export async function installNativeShell() {
  applyPlatformClasses();

  installLifecycle();
  installBackButton();
  installLinks();
  installHaptics();

  await installChrome();

  if (isNative) {
    console.info(`[ironpact] native shell ready (${platform})`);
  }
}
